import FetchWrapper from 'fetch-js-wrapper/index.min';
import store from './store';

var httpClient = function( baseURL ) {
    var httpFetchClient = new FetchWrapper( {
        baseURL: baseURL
    } );
    httpFetchClient.use( ( request ) => {
        const accessToken = localStorage.getItem( 'token' );
        if ( accessToken === null || accessToken.length === 0 ) {
            const refreshToken = localStorage.getItem( 'refreshToken' );
            if ( refreshToken === null || refreshToken.length === 0 ) {
                store.dispatch( 'logout' );
                return;
            }
        }
        request.headers[ 'Authorization' ] = `Bearer ${accessToken}`;
        return request;
    }, 'before' );

    httpFetchClient.use( async ( response, request ) => {
        if ( response.status === 401 ) {
            const baseURL = process.env.AUTH_API_URL;

            const refreshToken = localStorage.getItem( 'refreshToken' );

            if ( refreshToken === null || refreshToken.length === 0 ) {
                store.dispatch( 'logout' );
                return;
            }

            const options = {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${refreshToken}`
                }
            };

            const refreshResponse = await fetch( `${baseURL}/token/refresh`, options );

            if ( refreshResponse.status !== 200 ) {
                store.dispatch( 'logout' );
                return;
            }

            const tokens = await refreshResponse.json();

            localStorage.setItem( 'token', tokens.accessToken );

            // based on https://thinkwebcontent.atlassian.net/browse/IN-72 refresh token is no longer returned
            // localStorage.setItem( 'refreshToken', tokens.refreshToken );

            store.commit( 'auth', tokens.accessToken );

            return await httpFetchClient.request( response.url, request );
        }

        return response;
    }, 'after' );

    return httpFetchClient;
};

export { httpClient };



// WEBPACK FOOTER //
// ./src/httpclient.js